'use strict'
const {
    migrateStylableComponentsByCompType
} = require('../helpers/stylableMigration/migrateStylableComponentsByCompType')

const STYLABLE_BUTTON_COMPTYPE = 'wixui.StylableButton'
const STYLABLE_BUTTON_NON_STYLABLE_SKIN = 'wixui.skins.StylableButton'

const CSS_PROP_TO_VAR_NAME = {
    fill: 'color',
    height: 'size',
    width: 'size',
    transform: 'rotation',
    'justify-content': 'content-horizontal-alignment',
    'align-items': 'container-align-items',
    'flex-direction': 'container-flex-direction'
}

const CSS_LABEL_PROP_TO_VAR_NAME = {
    display: 'label-display',
    'margin-right': 'content-gap',
    'background-color': 'text-highlight',
    'text-decoration-line': 'text-decoration'
}

const migratePage = (structure, data, uniqueIdGenerator, clientSpecMap, magicObject) => {
    migrateStylableComponentsByCompType({
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        newSkin: STYLABLE_BUTTON_NON_STYLABLE_SKIN,
        compType: STYLABLE_BUTTON_COMPTYPE,
        useCssColor: true,
        magicObject,
        selectorsMappings: {
            '.root': {
                name: 'root',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::label': {
                name: 'label',
                properties: CSS_LABEL_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::icon': {
                name: 'icon',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::container': {
                name: 'container',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root:hover': {
                name: 'root-hover',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root:disabled': {
                name: 'root-disabled',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root:hover::label': {
                name: 'label-hover',
                root: 'label',
                properties: CSS_LABEL_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root:disabled::label': {
                name: 'label-disabled',
                root: 'label',
                properties: CSS_LABEL_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root:hover::icon': {
                name: 'hover-icon',
                root: 'icon',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root:disabled::icon': {
                name: 'disabled-icon',
                root: 'icon',
                properties: CSS_PROP_TO_VAR_NAME
            }
        }
    })
}

module.exports = {
    name: 'stylableButtonStylesFixer',
    version: 0,
    experimentalVersions: [
        {experiment: 'dm_migrateStylableButtonToNonStylable', version: 1},
        {experiment: 'dm_migrateBlocksWidgetsToNonStylable', version: 2}
    ],
    exec(pageJson, pageIdsArray, magicObject) {
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils

        if (!magicObject.isExperimentOpen('dm_migrateStylableButtonToNonStylable')) {
            return
        }

        const {data, structure} = pageJson
        migratePage(structure, data, uniqueIdGenerator, clientSpecMap, magicObject)
    },
    fixerRequiresReruns: true
}
